import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import adminAxios from "@/lib/axios";
import { handleApiError } from "@/lib/utils";

export interface ISkillCardsPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  heading?: string;
  heading_color?: string;
  sub_heading?: string;
  sub_heading_color?: string;
  cta_label?: string;
  cta_action?: string;
  cta_icon?: string;
  cta_url?: string;
  metadata?: any[];
  status?: boolean;
}

export async function createSkillCards(payload: Partial<ISkillCardsPayload>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.SKILL_CARDS.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateSkillCards(
  id: number,
  payload: Partial<ISkillCardsPayload>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.SKILL_CARDS.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
